export default __webpack_public_path__ + "static/media/economie.9fd45acc.png";